import { render, staticRenderFns } from "./flashSaleCourseAdd.vue?vue&type=template&id=328094d2&scoped=true"
import script from "./flashSaleCourseAdd.vue?vue&type=script&lang=js"
export * from "./flashSaleCourseAdd.vue?vue&type=script&lang=js"
import style0 from "./flashSaleCourseAdd.vue?vue&type=style&index=0&id=328094d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328094d2",
  null
  
)

export default component.exports